import { useMemo } from 'react'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ProfileAvatarIcon from '@mui/icons-material/Person'

import useAppStore from '$appStore'

/**
 * Header card identifying who is signed in: an avatar with the user's full name
 * and email. Reads the user details from the store directly so the orchestrator
 * only has to place it.
 */
const AppMenuHeader = () => {
  const userDetails = useAppStore((state) => state.userDetails)

  const { firstName, lastName, email } = userDetails

  const fullName = useMemo(
    () => [firstName, lastName].filter(Boolean).join(' ').trim(),
    [firstName, lastName]
  )

  return (
    <Box display="flex" alignItems="center" gap={1.5} padding={2}>
      <Avatar
        sx={{
          width: 44,
          height: 44,
          backgroundColor: 'header.background',
          color: 'header.foreground',
        }}
      >
        <ProfileAvatarIcon sx={{ fontSize: 28 }} />
      </Avatar>
      <Box minWidth={0}>
        <Typography variant="subtitle1" fontWeight={600} noWrap>
          {fullName || 'Account'}
        </Typography>
        {email && (
          <Typography variant="body2" color="text.secondary" noWrap>
            {email}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default AppMenuHeader
